namespace $ {

	class Widget_def_type extends $giper_baza_atom.of( $mol_schema_enum( $shm_hitalama_map_widget_def_types ) ){}
	class Widget_type_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_custom ){}
	class Widget_map extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map ){}
	class Widget_widgets extends $giper_baza_list_link.to( ()=> $giper_baza_entity ){}
	class Widget_inside_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_text_crdt extends $giper_baza_atom_link.to( ()=> $giper_baza_text ){}
	class Widget_use_text_from extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_settings_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_controlled_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_view_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_code_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_ai_request extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_ai_request ){}
	class Widget_component extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_component ){}
	class Widget_form extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_form ){}
	class Widget_form_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_form_custom ){}
	class Widget_table extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table ){}
	class Widget_chart extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_chart ){}
	class Widget_code_sql extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_code_sql ){}
	class Widget_iframe extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_iframe ){}
	class Widget_viewport_frame extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_viewport_frame ){}
	class Widget_file extends $giper_baza_atom_link.to( ()=> $shm_hitalama_file ){}
	class Widget_app extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_app ){}
	class Widget_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_custom ){}
	class Widget_drawing extends $giper_baza_atom_link_to( ()=> $shm_hitalama_map_widget_entity_drawing ){}

	class Widget_render_data_schema extends $mol_schema_record({
		title: $mol_schema_string,
		type: $mol_schema_string,
		text: $mol_schema_string,
		value_refs: $mol_schema_list( $mol_schema_string ),
		body_x: $mol_schema_float,
		body_y: $mol_schema_float,
		right_edge_x: $mol_schema_float,
		bottom_edge_y: $mol_schema_float,
		opacity: $mol_schema_float,
	}) {}

	class Widget_render_data extends $giper_baza_atom.of( Widget_render_data_schema ){}

	export const $shm_hitalama_map_widget_atoms_common = {

		Render_data: Widget_render_data,

		Body_x: $giper_baza_atom_real,
		Body_y: $giper_baza_atom_real,
		Bottom_edge_y: $giper_baza_atom_real,
		Right_edge_x: $giper_baza_atom_real,
		Top_edge_y: $giper_baza_atom_real,
		Left_edge_x: $giper_baza_atom_real,
		Type: Widget_def_type,
		Type_custom: Widget_type_custom,

		Created_at: $giper_baza_atom_real,

		Locked: $giper_baza_atom_bool,

		Hide_head_tools: $giper_baza_atom_bool,

		Map: Widget_map,

		Tags: $giper_baza_list_str,

		Widgets: Widget_widgets,
		Container_widget: Widget_inside_widget,

		Enabled: $giper_baza_atom_bool,

		Data: $giper_baza_atom_dict, //todo: keys for different datas
		Data_method: $giper_baza_atom_text,

		Description: $giper_baza_atom_text,
		Link_to_viewport: $giper_baza_atom_text,

	} as const

	export const $shm_hitalama_map_widget_atoms_style = {

		Image: $giper_baza_file,
		Color: $giper_baza_atom_text,
		Font_size: $giper_baza_atom_real,
		Font_family: $giper_baza_atom_text,
		Opacity: $giper_baza_atom_real,
		Background_color: $giper_baza_atom_text,
		Background_opacity: $giper_baza_atom_real,
		Border_color: $giper_baza_atom_text,
		Border_opacity: $giper_baza_atom_real,
		Border_width: $giper_baza_atom_real,
		Border_style: $giper_baza_atom_text,
		Auto_height: $giper_baza_atom_bool,

	} as const

	export const $shm_hitalama_map_widget_atoms_text = {

		Text_atom: $giper_baza_atom_text,
		Text_crdt: Widget_text_crdt,
		Text_crdt_disabled: $giper_baza_atom_bool,

		Use_text_from: Widget_use_text_from,

		/** @deprecated */ Text: $giper_baza_text,

	} as const

	export const $shm_hitalama_map_widget_atoms_connection = {

		Settings_widget: Widget_settings_widget,
		Controlled_widget: Widget_controlled_widget,
		View_widget: Widget_view_widget,
		Code_widget: Widget_code_widget,

	} as const

	export const $shm_hitalama_map_widget_atoms_entities = {

		Ai_request: Widget_ai_request,
		Component: Widget_component,
		Form: Widget_form,
		Form_edit: Widget_form,
		Form_custom: Widget_form_custom,
		Table: Widget_table,
		Chart: Widget_chart,
		Code_sql: Widget_code_sql,
		Iframe: Widget_iframe,
		Viewport_frame: Widget_viewport_frame,
		File: Widget_file,
		App: Widget_app,
		Custom: Widget_custom,
		Drawing: Widget_drawing,

	} as const

	export function $shm_hitalama_map_widget_preprocessed_code( text: string ) {
		const template = text.startsWith( '$'+'value' ) ? '${' + text + '}' : text
		return 'return `'+template+'`'
	}

	export function $shm_hitalama_map_widget_preprocessed_needed( text: string ) {
		return text.startsWith( '$'+'value' ) || text.includes( '${' ) || text.includes( '`' )
	}

	export function $shm_hitalama_map_widget_value_refs( text: string ) {
		const refs = new Set< string >
		const regex = new RegExp( '\\$' + '(?:value|file|widget|data|bind_value)\\s*\\(\\s*[\'"]([^\'"\\n]*)[\'"]', 'g' )
		for( const match of text.matchAll( regex ) ) refs.add( match[1] )
		return [ ... refs ]
	}

	export class $shm_hitalama_map_widget extends $giper_baza_entity.with({

		... $shm_hitalama_map_widget_atoms_common,
		... $shm_hitalama_map_widget_atoms_style,
		... $shm_hitalama_map_widget_atoms_text,
		... $shm_hitalama_map_widget_atoms_connection,
		... $shm_hitalama_map_widget_atoms_entities,

	}){

		render_data_legacy(): typeof Widget_render_data_schema.default {
			return {
				title: super.title() || this.link_str(),
				type: this.type_legacy(),
				text: this.text_legacy(),
				value_refs: $shm_hitalama_map_widget_value_refs( this.text_legacy() ),
				body_x: this.Body_x()?.val() ?? 0,
				body_y: this.Body_y()?.val() ?? 0,
				right_edge_x: this.Right_edge_x()?.val() ?? 0,
				bottom_edge_y: this.Bottom_edge_y()?.val() ?? 0,
				opacity: this.Opacity()?.val() ?? 1,
			}
		}

		@ $mol_mem
		render_data( next?: typeof Widget_render_data_schema.default ) {
			const data = next !== undefined
				? this.Render_data( null )?.val( next ) ?? Widget_render_data_schema.default
				: this.Render_data()?.val() ?? this.render_data_legacy()

			const map = this.map()
			if( map ) $shm_hitalama_map_journal_recorder.event_add(
				map,
				this,
				data,
				next === undefined ? 'read' : 'write',
			)

			return data
		}

		render_data_patch( next: Partial< typeof Widget_render_data_schema.default > ) {
			if( next.text !== undefined && next.value_refs === undefined ) {
				next = { ... next, value_refs: $shm_hitalama_map_widget_value_refs( next.text ) }
			}
			return this.render_data({ ... this.render_data(), ... next })
		}

		@ $mol_mem
		value_refs() {
			return this.render_data().value_refs
		}

		get title() { return ( next?: string )=> {
			if( next === undefined ) {
				return this.render_data().title || this.link_str()
			}
			this.render_data_patch({ title: next })
			return next
		} }

		widgets( next?: $shm_hitalama_map_widget[] ) {
			const widgets = this.Widgets(next)?.remote_list( next ) ?? []
			const casted = widgets.map( e => e.cast( $shm_hitalama_map_widget ) )
			return next === undefined ? casted.filter( widget => !widget.removed() ) : casted
		}

		container_widget( next?: null | $shm_hitalama_map_widget ) {
			return this.Container_widget(next)?.remote( next )
		}

		enabled( next?: boolean | null ) {
			return this.Enabled(next)?.val( next )
		}

		settings_widget( next?: null | $shm_hitalama_map_widget ) {
			return this.Settings_widget(next)?.remote( next )!
		}

		controlled_widget( next?: null | $shm_hitalama_map_widget ) {
			return this.Controlled_widget(next)?.remote( next )!
		}

		view_widget( next?: null | $shm_hitalama_map_widget ) {
			return this.View_widget(next)?.remote( next )!
		}

		code_widget( next?: null | $shm_hitalama_map_widget ) {
			return this.Code_widget(next)?.remote( next )!
		}

		code_view_widget() {
			return $shm_hitalama_map_widget_def_code_view_type( this.type() ) !== null
		}

		@ $mol_action
		code_view_widget_open() {
			if( !this.code_view_widget() ) return null

			const view = this.view_widget()
			const pos = [ this.body_x() + this.right_edge_x() + 10, this.body_y() ]
			const width = Math.max( 600, this.right_edge_x() )
			const height = Math.max( 400, this.bottom_edge_y() )

			if( view ) {
				if( view.removed() ) this.map().widget_restore( view.link() )
				return view
			}

			const view_type = $shm_hitalama_map_widget_def_code_view_type( this.type() )
			if( !view_type ) return null

			const created = this.map().widget_add( view_type, pos, width, height )
			created?.title( 'View: ' + this.title() )
			created?.Use_text_from(null)?.remote( this )
			created?.code_widget( this )
			if( view_type === 'iframe' ) created?.iframe().html_use( true )
			this.view_widget( created )
			return created
		}
		
		settings_widget_enabled( next?: boolean ) {
			const settings = this.settings_widget()
			if( next === undefined ) {
				if( !settings ) return false
				return ! settings.removed()
			}

			if( next == false ) {
				if( settings ) this.map().widget_cut( settings.link() )
				return false
			}

			const pos = [ this.body_x() + this.right_edge_x() + 10, this.body_y() ]
			let width = 600
			switch (this.type()) {
				case 'chart': width = 300; break;
				case 'echarts': width = 320; break;
				case 'tabulator': width = 320; break;
				case 'table': width = 420; break;
				case 'table_novirt': width = 420; break;
			}

			const height = Math.max(260, this.bottom_edge_y())
			if( settings ) {
				// settings?.Body_x(null)?.val( pos[0] )
				// settings?.Body_y(null)?.val( pos[1] )
				// settings?.Right_edge_x(null)?.val( width )
				// settings?.Bottom_edge_y(null)?.val( height )
				this.map().widget_restore( settings.link() )
			} else {
				const settings_type = $shm_hitalama_map_widget_def_settings_type( this.type() ) ?? 'settings'

				const w = this.map().widget_add( settings_type, pos, width, height )
				w?.controlled_widget(this)
				this.settings_widget( w )
			}
			return true
		}

		link_str() {
			return this.link().str
		}

		@ $mol_mem
		view( next?: $mol_view ) {
			return next
		}
		
		@ $mol_mem
		map() {
			return this.Map()?.remote()!
		}

		@ $mol_mem
		removed() {
			return Boolean( this.map()?.Widgets_removed_list()?.remote_list().find( ( b: $shm_hitalama_map_widget ) => b.link_str() == this.link_str() ) )
		}

		created_at() {
			return this.Created_at()?.val()
		}

		z_descendants(): $shm_hitalama_map_widget[] {
			return this.widgets().flatMap( widget => [ widget, ... widget.z_descendants() ] )
		}

		z_block(): $shm_hitalama_map_widget[] {
			return this.type() == 'group'
				? [ this, ... this.z_descendants() ]
				: [ this ]
		}

		z_move_block( block: readonly $shm_hitalama_map_widget[], target: number ) {
			const list = this.map()?.Widgets_list(null)
			const widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
			const block_links = new Set( block.map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
			const block_ordered = widgets.filter( ( widget: $shm_hitalama_map_widget ) => block_links.has( widget.link_str() ) )
			if( block_ordered.length === 0 ) return widgets

			const target_limited = Math.max( 0, Math.min( target, widgets.length - block_ordered.length ) )
			const next_widgets = widgets.filter( ( widget: $shm_hitalama_map_widget ) => !block_links.has( widget.link_str() ) )
			next_widgets.splice( target_limited, 0, ... block_ordered )
			list?.remote_list( next_widgets as any )
			return next_widgets
		}

		z( next?: number ) {
			const list = this.map()?.Widgets_list( next === undefined ? undefined : null )
			const widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
			const current = widgets.findIndex( ( widget: $shm_hitalama_map_widget ) => widget.link_str() === this.link_str() )

			if( next === undefined ) return current < 0 ? 0 : current
			if( current < 0 || widgets.length === 0 ) return 0

			const block = this.z_block()
			const parent = this.container_widget()

			if( parent ) {
				const parent_links = new Set( parent.z_descendants().map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
				const block_links = new Set( block.map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
				const parent_indexes = widgets.flatMap( ( widget: $shm_hitalama_map_widget, index: number ) =>
					parent_links.has( widget.link_str() ) ? [ index ] : []
				)

				if( parent_indexes.length === 0 ) return current

				const min = Math.min( ... parent_indexes )
				const max = Math.max( ... parent_indexes ) - block_links.size + 1
				const target = Math.max( min, Math.min( Math.round( next ), max ) )
				this.z_move_block( block, target )
				return target
			}

			const target = Math.max( 0, Math.min( Math.round( next ), widgets.length - block.length ) )
			this.z_move_block( block, target )
			return target
		}

		@ $mol_mem
		css_id() {
			$mol_wire_solid()
			return CSS.escape( this.view()?.dom_id()! )
		}

		text_crdt_disabled( next?: boolean ) {
			return this.Text_crdt_disabled(next)?.val(next) ?? false
		}

		type_legacy() {
			return $shm_hitalama_map_widget_def_type_normalize( this.Type()?.val() )
		}

		text_legacy( next?: string ) {
			if( this.type_legacy() == 'file' ) {
				return this.File()?.remote()?.text() ?? ''
			}

			if( next && next.length > 5000 ) {
				this.text_crdt_disabled( true )
			}
			if( this.text_crdt_disabled() ) {
				return this.Text_atom(next)?.val(next) ?? ''
			}
			
			return this.Text_crdt(next)?.ensure( this.land() )!.value(next) ?? ''
		}

		@ $mol_mem
		text( next?: string ) {
			if( next === undefined ) return this.Render_data()?.val()?.text ?? this.text_legacy()
			if( next.length > 5000 ) this.text_crdt_disabled( true )
			this.render_data_patch({ text: next })
			return next
		}

		link_to_viewport( next?: string ) {
			return this.Link_to_viewport(next)?.val(next) ?? ''
		}

		description( next?: string ) {
			return this.Description(next)?.val(next) ?? ''
		}

		locked( next?: boolean ) {
			return this.Locked(next)?.val(next) ?? false
		}

		hide_head_tools( next?: boolean ) {
			return this.Hide_head_tools(next)?.val(next) ?? false
		}

		tags( next?: readonly string[] ) {
			return (this.Tags(next)?.items( next ) ?? []) as string[]
		}
		
		// @ $mol_action
		// tag_add( tag: string ) {
		// 	this.tags( [ tag, ...this.tags() ] )
		// }

		code( next?: string ): string {
			const text_from = this.Use_text_from()?.remote()
			if( text_from ) return text_from.text( next ) ?? ''

			return this.text( next ) ?? ''
		}

		@ $mol_mem
		data( next?: any ) {
			const method = this.Data_method()?.val()
			if( method ) {
				return this.map().execute( `const next = $${''}next\n${ method }`, { [ '$' + 'next' ]: next, [ '$' + 'this_widget' ]: this } )
			}
			return this.Data(next)?.val(next)
		}

		@ $mol_mem
		body_x( next?: number ) {
			if( next === undefined ) return this.render_data().body_x
			this.render_data_patch({ body_x: next })
			return next
		}

		@ $mol_mem
		body_y( next?: number ) {
			if( next === undefined ) return this.render_data().body_y
			this.render_data_patch({ body_y: next })
			return next
		}

		@ $mol_mem
		right_edge_x( next?: number ) {
			if( next === undefined ) return this.render_data().right_edge_x
			this.render_data_patch({ right_edge_x: next })
			return next
		}

		@ $mol_mem
		bottom_edge_y( next?: number ) {
			if( next === undefined ) return this.render_data().bottom_edge_y
			this.render_data_patch({ bottom_edge_y: next })
			return next
		}

		@ $mol_mem
		opacity( next?: number ) {
			if( next === undefined ) return this.render_data().opacity
			this.render_data_patch({ opacity: next })
			return next
		}

		color( next?: string ) {
			return this.Color(next)?.val(next) ?? ''
		}

		background_color_default() {
			return $shm_hitalama_map_widget_def_background_default( this.type() )
		}

		background_color( next?: string ) {
			return this.Background_color(next)?.val(next) || this.background_color_default()
		}

		background_opacity( next?: number ) {
			return this.Background_opacity(next)?.val(next) ?? 1
		}

		border_color( next?: string ) {
			return this.Border_color(next)?.val(next) ?? 'var(--mol_theme_text)'
		}

		border_opacity( next?: number ) {
			return this.Border_opacity(next)?.val(next) ?? 1
		}

		border_width( next?: number ) {
			return this.Border_width(next)?.val(next) ?? 0
		}

		border_style( next?: string ) {
			return this.Border_style(next)?.val(next) ?? 'solid'
		}

		font_size( next?: number ) {
			return this.Font_size(next)?.val(next) ?? 14
		}

		font_family( next?: string ) {
			return this.Font_family(next)?.val(next) ?? ''
		}

		auto_height( next?: boolean ) {
			return this.Auto_height(next)?.val(next) ?? false
		}

		@ $mol_mem
		type( next?: $shm_hitalama_map_widget_def_type_name ) {
			if( next === undefined ) return $shm_hitalama_map_widget_def_type_normalize( this.render_data().type )
			const type = $shm_hitalama_map_widget_def_type_normalize( next )
			this.render_data_patch({ type })
			return type
		}

		@ $mol_mem
		ai_request() {
			return this.Ai_request(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		component() {
			return this.Component(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		form() {
			const remote = this.Form(null)?.remote()
			if( remote ) return remote

			const form = this.map().Search_statistics(null)?.make( null )!
			this.Form(null)?.remote( form )
			return form
		}

		@ $mol_mem
		chart() {
			const remote = this.Chart(null)?.remote()
			if( remote ) return remote

			const chart = this.map().Charts(null)?.make( this.land() )!
			chart.Widget(null)?.remote( this )
			this.Chart(null)?.remote( chart )
			return chart
		}

		@ $mol_mem
		code_sql() {
			return this.Code_sql(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		viewport_frame() {
			return this.Viewport_frame(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		form_custom() {
			return this.Form_custom(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		iframe() {
			return this.Iframe(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		app() {
			const app = this.App(null)?.ensure( this.land() )!
			app.Widget(null)?.remote( this )
			return app
		}

		@ $mol_mem
		drawing() {
			return this.Drawing(null)?.ensure( this.land() )!
		}
		
		@ $mol_mem
		preprocessed( page?: $shm_hitalama_map_page, view?: $mol_view ) {
			const text = this.text()
			if( ! $shm_hitalama_map_widget_preprocessed_needed( text ) ) return text
			const map = this.Map()?.remote()!
			return map.execute( $shm_hitalama_map_widget_preprocessed_code( text ), { [ '$' + 'page' ]: page, [ '$' + 'this_widget' ]: this, [ '$' + 'view' ]: view } )
		}

		@ $mol_mem
		table() {
			const remote = this.Table(null)?.remote()
			if( remote ) return remote

			const table = this.map().Tables(null)?.make( this.land() )!
			this.Table(null)?.remote( table )
			return table
		}

		@ $mol_mem
		table_head( next?: any ) {
			return this.table()?.table_head( next )
		}

		@ $mol_mem
		table_col_types( next?: any ) {
			return this.table()?.col_types( next )
		}

		@ $mol_mem
		table_rows( next?: any ) {
			return this.table()?.table_rows( next )
		}

		@ $mol_mem
		table_data( data?: { head: string[], rows: any[][] } ) {
			return this.table()?.table_data( data )
		}

		/** @depcreated */
		@ $mol_mem
		file_str() {
			return this.text()
		}

	}

}
